import { render, staticRenderFns } from "./contact-import-component.vue?vue&type=template&id=bf655b36&"
import script from "./contact-import-component.vue?vue&type=script&lang=js&"
export * from "./contact-import-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports